<!--
 * @Author: Shber
 * @Date: 2022-02-16 12:25:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-11-29 17:18:23
 * @Description:
-->
<template>
  <div class="tip_info">
    <input id="shareImg" type="hidden" :value="shareData.share_img">
    <input id="shareLink" type="hidden" :value="shareData.share_link">
    <input id="shareTitle" type="hidden" :value="shareData.share_title">
    <input id="shareDesc" type="hidden" :value="shareData.share_desc">
  </div>
</template>

<script>
import utils from '@/utils/utils'
import { reactive, toRefs, watch, defineComponent } from 'vue'
export default defineComponent({
  name: 'ShareInfo',
  props: {
    shareInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const state = reactive({ shareData: {} })

    watch(props, (newVal, oldVal) => {
      console.log('分享数据', props.shareInfo)
      state.shareData = props.shareInfo

      utils.wechatShare(state.shareData)
      utils.miniShare(state.shareData)
    }, {
      immediate: true
    })

    return { ...toRefs(state) }
  }
})
</script>

